import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import roleoAutomaticoEsCL from './locales/es-CL.json';
import roleoAutomaticoEnUS from './locales/en-US.json';
import roleoAutomaticoPtBR from './locales/pt-BR.json';

export const roleoAutomaticoI18n = buildScopedI18n({
  esCL: roleoAutomaticoEsCL,
  enUS: roleoAutomaticoEnUS,
  ptBR: roleoAutomaticoPtBR,
});